require('./mortgageRequestPreApprovalStepFourth.scss');
//@Vendor
const React = require('react');
const PropTypes = require('prop-types');
//@core
const { FormattedText } = require('core/i18n').i18n;
//@constants
const { EURO_TEXT, PERCENTAGE_SYMBOL } = require('constants/index');
const letterURL = require('assets/images/letter-hipo-openbank.png');
const { mortgageProductCatalogIdentifiers, afiMortgageProductTypes, mortgageRequestPreApprovalCommons } = require('constants/mortgageRequestPreApproval');
const { MORTGAGE_COLLECTIVE_PRODUCT_ALIAS } = mortgageRequestPreApprovalCommons;
// @components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const { CollectiveTag } = require('components/commons/collectiveTag/collectiveTag');
const MortgagesCollectiveTagTooltip = require('components/mortgagesCollectiveTagTooltip/mortgagesCollectiveTagTooltip');

// @utilities
const mortgageRequestPreApprovalHelper = require('../mortgageRequestPreApprovalHelper');
const {
    formatAmount,
} = require('utilities/currencyHelper');
const { mortgagesPreApprovalIntrestPeriodSubtitle } = require('utilities/mortgageHelper');

class MortgageRequestPreApprovalStepFourth extends React.Component {

    componentDidMount() {
        const { requestConditions } = this.props;
        if (requestConditions) {
            requestConditions();
        }
    }

    buildCollectiveMessages(mortgageType, defaultMortgageData, collectiveMortgageData) {
        const className = "mortgage-request-preapproval-step-fourth__header-quota__tae";
        if (afiMortgageProductTypes.FIJO === mortgageType) {
            const stringValue = ['mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_quotaCollectiveFixed']
            return mortgageRequestPreApprovalHelper.getCollectiveMortgageProductMessage(mortgageType, defaultMortgageData,
                collectiveMortgageData, stringValue, className);

        } else if (afiMortgageProductTypes.VARIABLE === mortgageType) {
            const stringValue = ['mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_quotaCollectiveVariable']
            return mortgageRequestPreApprovalHelper.getCollectiveMortgageProductMessage(mortgageType, defaultMortgageData,
                collectiveMortgageData, stringValue, className);
        } else {
            const stringValue = ['mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_quotaCollectiveMixedTIN',
                'mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_quotaCollectiveMixedTAE'];
            return mortgageRequestPreApprovalHelper.getCollectiveMortgageProductMessage(mortgageType, defaultMortgageData,
                collectiveMortgageData, stringValue, className);
        }
    }

    buildHeader() {
        const { immMortgageRequest, immCollectives, mortgageConditions } = this.props;
        const isCollective = immCollectives.getIn(['collective', 'isCollective']);
        const productCatalog = immMortgageRequest.get('productCatalogWF');
        const hasCollectiveBenefits = mortgageRequestPreApprovalHelper.hasCollectiveBenefits(productCatalog);
        const mortgageType = afiMortgageProductTypes[immMortgageRequest.get('productType')];
        let preapprovalQuotaParams, formattedQuota;
        const preApprovalQuotaCost = immMortgageRequest.get('monthlyFeeWF');
        if (preApprovalQuotaCost) {
            preapprovalQuotaParams = {
                currency: preApprovalQuotaCost,
                symbol: EURO_TEXT,
                withDecimals: true
            };
            formattedQuota = MortgageRequestCurrencyHelp(preapprovalQuotaParams);
        } else {
            formattedQuota = 'TBD';
        }
        const mortgageCost = immMortgageRequest.get('moneyNeed');
        const mortgageCostParams = {
            currency: mortgageCost,
            symbol: EURO_TEXT,
            withDecimals: false
        };
        const formattedMortgageCost = MortgageRequestCurrencyHelp(mortgageCostParams);
        const mortgageTerm = Number(immMortgageRequest.get('timeMoneyReturn'));
        const mortgageTin = `${formatAmount(immMortgageRequest.get('tin'))}${PERCENTAGE_SYMBOL}`;
        const mortgageTae = `${formatAmount(immMortgageRequest.get('tae'))}${PERCENTAGE_SYMBOL}`;
        const productType = immMortgageRequest.get('productType');
        let tooltipContent = '';

        const conditions = mortgageConditions.get('conditions');
        const mortgagesIntrestText = mortgagesPreApprovalIntrestPeriodSubtitle(mortgageTin, mortgageTae, conditions);
        
        let feeAndTaxes = (<h2>
            <span className="mortgage-request-preapproval-step-fourth__header-quota__value">{formattedQuota}</span>
            <span className="mortgage-request-preapproval-step-fourth__header-quota__tae"> {mortgagesIntrestText}</span>
        </h2>);

        if (isCollective && hasCollectiveBenefits) {
            // Tooltip Content start
            const taxes = {
                tin: !isNaN(hasCollectiveBenefits.tin) ? `${hasCollectiveBenefits.tin}%` : hasCollectiveBenefits.tin,
                tae: !isNaN(hasCollectiveBenefits.tae) ? `${hasCollectiveBenefits.tae}%` : hasCollectiveBenefits.tae,
                euribor: hasCollectiveBenefits.euribor
            };
            tooltipContent = (
                <MortgagesCollectiveTagTooltip
                    taxes={taxes}
                    mortgageType={productType}
                    monthlyFee={hasCollectiveBenefits.cuota}
                />
            );
            // Tooltip Content finish
            const defaultValue = productCatalog.find(product => product.get('identificador') === mortgageProductCatalogIdentifiers.DEFAULT).toJS();
            const tinTaemessage = this.buildCollectiveMessages(mortgageType, defaultValue, hasCollectiveBenefits);
            let formattedCollectiveQuota = 'TBD';
            if (!isNaN(hasCollectiveBenefits.cuota)) {
                formattedCollectiveQuota = MortgageRequestCurrencyHelp({ currency: hasCollectiveBenefits.cuota, symbol: EURO_TEXT, withDecimals: true });
            }
            feeAndTaxes = (<h2>
                <span className="mortgage-request-preapproval-step-fourth__header-quota__value"><s><span>{formattedQuota}</span></s> {formattedCollectiveQuota}</span>
                {tinTaemessage}
            </h2>);
        }
        return (
            <header className="mortgage-request-preapproval-step-fourth__header">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="mortgage-request-preapproval-step-fourth__header-title">
                            <FormattedText
                                injectedStrings={[mortgageType]}
                                value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_title"
                            />
                            <CollectiveTag
                                extraClass={"calculate-quota__collective-tag"}
                                productAlias={MORTGAGE_COLLECTIVE_PRODUCT_ALIAS}
                                tooltipContent={tooltipContent}
                            />
                        </h2>
                        <h3 className="mortgage-request-preapproval-step-fourth__header-subtitle">
                            <FormattedText
                                injectedStrings={[formattedMortgageCost, mortgageTerm]}
                                value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_subTitle"
                            />
                        </h3>
                        <div className="mortgage-request-preapproval-step-fourth__header-quota">
                            {feeAndTaxes}
                        </div>
                        <span className="mortgage-request-preapproval-step-fourth__header-explanatory-text">
                            <FormattedText value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_explanatoryText" />
                        </span>
                    </div>
                </div>
            </header >
        );
    }

    buildbodySection() {
        const { immMortgageRequest } = this.props;
        const isInsurance = immMortgageRequest.get('insurance');
        const insuranceBuildMortgageRequest =
            isInsurance &&
            (
                <li>
                    <span className="mortgage-request-preapproval-step-fourth__request-advantages-item">
                        <FormattedText value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_insurance" />
                    </span>
                </li>
            );

        return (
            <div className="row">
                <div className="col-md-2 col-md-offset-1 mortgage-request-preapproval-step-fourth__pre-approval-letter">
                    <img src={letterURL} alt="letter-openbank" />
                </div>
                <div className="col-md-8 mortgage-request-preapproval-step-fourth__request-advantages">
                    <span className="mortgage-request-preapproval-step-fourth__request-advantages-title">
                        <FormattedText value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_advantagesTitle" />
                    </span>
                    <ul className="mortgage-request-preapproval-step-fourth__request-advantages-list">
                        <li>
                            <span className="mortgage-request-preapproval-step-fourth__request-advantages-item">
                                <FormattedText value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_advantagesFirstItemNormal" />
                                <FormattedText value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_advantagesFirstItemBold" className="mortgage-request-preapproval-step-fourth__request-advantages-item--bold" />
                                <FormattedText value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_advantagesFirstItemSecondNormal" />
                            </span>
                        </li>
                        <li>
                            <span className="mortgage-request-preapproval-step-fourth__request-advantages-item">
                                <FormattedText value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_advantagesSecondItemNormal" />
                                <FormattedText className="mortgage-request-preapproval-step-fourth__request-advantages-item--bold" value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_advantagesSecondItemBold" />
                                <FormattedText value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_advantagesSecondItemSecondNormal" />
                            </span>
                        </li>
                        <li>
                            <span className="mortgage-request-preapproval-step-fourth__request-advantages-item">
                                <FormattedText value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_advantagesThirdItemNormal" />
                                <FormattedText className="mortgage-request-preapproval-step-fourth__request-advantages-item--bold" value="mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_advantagesThirdItemBold" />
                            </span>
                        </li>
                        {insuranceBuildMortgageRequest}
                    </ul>
                </div>
            </div>
        );
    }

    render() {
        const headerSection = this.buildHeader();
        const bodySection = this.buildbodySection();

        return (
            <section className="mortgage-request-preapproval-step-fourth">
                {headerSection}
                {bodySection}
            </section >
        );
    }
}

MortgageRequestPreApprovalStepFourth.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired,
    immCollectives: PropTypes.object.isRequired,
    immTaxesInformation: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    mortgageConditions: PropTypes.object.isRequired,
    requestConditions: PropTypes.func,
}

module.exports = MortgageRequestPreApprovalStepFourth;
